(function() {
    'use strict';

    angular.module('app.archivoReloj', []);
})();
